import { Link } from 'react-router-dom'

import { PodiumWordmark } from '@/components/brand/podium-wordmark'
import { SocialIconButton } from '@/components/marketing/social-icon-button'
import { marketingFooterWatermarkSrc } from '@/config/marketing-assets.config'
import { footerSections, footerSocialLinks } from '@/config/marketing-nav.config'
import type { NavLink } from '@/config/marketing-nav.config'

function FooterNavLink({ link }: { link: NavLink }) {
  if (link.href.startsWith('http') || link.href === '#') {
    return (
      <a href={link.href} className="marketing-footer__link">
        {link.label}
      </a>
    )
  }

  return (
    <Link to={link.href} className="marketing-footer__link">
      {link.label}
    </Link>
  )
}

export function MarketingFooter() {
  return (
    <footer className="marketing-footer">
      <div className="marketing-footer__bg" aria-hidden>
        <img src={marketingFooterWatermarkSrc()} alt="" />
      </div>

      <div className="marketing-container marketing-footer__inner">
        <div className="marketing-footer__top">
          <nav className="marketing-footer__columns" aria-label="Footer">
            {footerSections.map((section) => (
              <div key={section.title} className="marketing-footer__column">
                <h3 className="marketing-footer__heading">{section.title}</h3>
                <ul className="marketing-footer__links">
                  {section.links.map((link) => (
                    <li key={`${section.title}-${link.label}`}>
                      <FooterNavLink link={link} />
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </nav>

          <Link to="/" className="marketing-footer__logo" aria-label="Podium Markets home">
            <PodiumWordmark variant="dark" height={40} className="h-10 w-auto" aria-hidden />
          </Link>
        </div>

        <div className="marketing-footer__bottom">
          <p className="marketing-footer__copyright">
            <span>© 2026 Podium Markets Media, LLC</span>
          </p>

          <div className="marketing-footer__socials">
            {footerSocialLinks.map((link) => (
              <SocialIconButton
                key={link.platform}
                platform={link.platform}
                href={link.href}
                label={link.label}
              />
            ))}
          </div>
        </div>
      </div>
    </footer>
  )
}
